module.exports = __webpack_public_path__ + "static/media/monument.d445d431.svg";